type ConsoleType = 'log' | 'debug' | 'info' | 'warn' | 'error' | 'table'

const useDebugger = () => {
  const isDebugOn = (import.meta.env.VITE_DEBUG as string) === 'true' ? true : false

  const debug = (type: ConsoleType, ...args: unknown[]) => {
    if (isDebugOn) {
      const consoleType = console[type]

      if (consoleType) {
        if (type === 'table') {
          consoleType(...args)
        } else {
          consoleType(
            `%cDebug Log`,
            `color: #333; background-color: #ffca13; border-radius: 5px; padding: 2px 4px; font-size: 10px; font-family: sans-serif; font-weight: bold`,
            ...args,
          )
        }
      } else {
        console.log(`[${type.toUpperCase()}]`, ...args)
      }
    }
  }

  return {
    isDebugOn,
    debug,
  }
}

export default useDebugger
